export const FINANCE_COST_SCHEMA_VERSION = 2;

export const COST_SCOPE = {
  PRODUCT: 'product',
  PRODUCT_TYPE: 'product_type',
  CATEGORY: 'category',
  DEFAULT: 'default'
};

export const COST_SCOPE_PRIORITY = {
  [COST_SCOPE.PRODUCT]: 400,
  [COST_SCOPE.PRODUCT_TYPE]: 300,
  [COST_SCOPE.CATEGORY]: 200,
  [COST_SCOPE.DEFAULT]: 100
};

export const COST_METHOD = {
  GOLD_FORMULA: 'gold_formula',
  MANUAL_TRY: 'manual_try',
  UNIT_COST: 'unit_cost',
  FX_COST: 'fx_cost',
  PURCHASE_AMOUNT: 'purchase_amount',
  HAM_VERI_SELL: 'ham_veri_sell',
  CUSTOM: 'custom'
};

export const GOLD_RATE_SOURCE = {
  LIVE_BUY: 'live_buy',
  LIVE_SELL: 'live_sell',
  PRODUCT: 'product',
  MANUAL: 'manual'
};

export const LABOR_MODEL = {
  INHERIT: 'inherit',
  MILYEM: 'milyem',
  ADET_MILYEM: 'adet_milyem',
  PER_GRAM_TRY: 'per_gram_try',
  FIXED_TRY: 'fixed_try',
  NONE: 'none'
};

export const ADDITIONAL_CALC = {
  FIXED: 'fixed',
  PER_UNIT: 'per_unit',
  PER_GRAM: 'per_gram'
};

export const COST_STATUS = {
  AUTOMATIC: 'OTOMATİK',
  MANUAL: 'MANUEL',
  MISSING: 'EKSİK',
  NEEDS_REVIEW: 'KONTROL GEREKİYOR'
};

export const COST_STATUS_CODE = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
  MISSING: 'MISSING',
  NEEDS_REVIEW: 'NEEDS_REVIEW'
};

export const QUALITY_ISSUE = {
  MISSING_MILYEM: 'milyem_eksik',
  MISSING_GRAM: 'gram_eksik',
  BAD_LABOR: 'iscilik_hatali',
  MISSING_RULE: 'maliyet_kurali_yok',
  MISSING_RATE: 'kur_kaynagi_yok',
  MANUAL_ZERO: 'manuel_maliyet_0',
  MISSING_BARCODE: 'barkod_yok',
  CALC_FAILED: 'maliyet_hesaplanamadi',
  MISSING_UNIT_COST: 'birim_maliyet_yok',
  MISSING_FX_RATE: 'doviz_alis_kuru_yok'
};

export const ADDITIONAL_COST_PRESETS = [
  { key: 'tas', name: 'Taş' },
  { key: 'montur', name: 'Montür' },
  { key: 'rodaj', name: 'Rodaj' },
  { key: 'kaplama', name: 'Kaplama' },
  { key: 'lazer', name: 'Lazer' },
  { key: 'ambalaj', name: 'Kutu / Ambalaj' },
  { key: 'sertifika', name: 'Sertifika' },
  { key: 'kargoTedarik', name: 'Kargo / Tedarik' },
  { key: 'diger', name: 'Diğer' }
];

export const FINANCE_COLLECTIONS = {
  RULES: 'finansMaliyetKurallari',
  RULE_AUDIT: 'finansMaliyetKuralGecmisi',
  SETTINGS: 'finansAyarlari',
  EXPENSES: 'finansGiderler'
};

export const FINANCE_PERIOD = {
  GUN: 'bugun',
  HAFTA: 'bu_hafta',
  AY: 'bu_ay'
};

export const GIDER_KALEMLERI = [
  { id: 'kira', label: 'Kira', defaultType: 'sabit' },
  { id: 'personel', label: 'Personel', defaultType: 'sabit' },
  { id: 'maas', label: 'Maaş', defaultType: 'sabit' },
  { id: 'sgk', label: 'SGK', defaultType: 'sabit' },
  { id: 'prim', label: 'Prim', defaultType: 'degisken' },
  { id: 'yemek', label: 'Yemek', defaultType: 'degisken' },
  { id: 'yol', label: 'Yol', defaultType: 'degisken' },
  { id: 'elektrik', label: 'Elektrik', defaultType: 'sabit' },
  { id: 'su', label: 'Su', defaultType: 'sabit' },
  { id: 'dogalgaz', label: 'Doğalgaz', defaultType: 'sabit' },
  { id: 'internet', label: 'İnternet', defaultType: 'sabit' },
  { id: 'telefon', label: 'Telefon', defaultType: 'sabit' },
  { id: 'reklam', label: 'Reklam', defaultType: 'degisken' },
  { id: 'pazarlama', label: 'Pazarlama', defaultType: 'degisken' },
  { id: 'yazilim', label: 'Yazılım', defaultType: 'sabit' },
  { id: 'muhasebe', label: 'Muhasebe', defaultType: 'sabit' },
  { id: 'banka_komisyonu', label: 'Banka Komisyonu', defaultType: 'degisken' },
  { id: 'pos_komisyonu', label: 'POS Komisyonu', defaultType: 'degisken' },
  { id: 'kargo', label: 'Kargo', defaultType: 'degisken' },
  { id: 'guvenlik', label: 'Güvenlik', defaultType: 'sabit' },
  { id: 'temizlik', label: 'Temizlik', defaultType: 'sabit' },
  { id: 'bakim', label: 'Bakım / Onarım', defaultType: 'degisken' },
  { id: 'vergi', label: 'Vergi / Harç', defaultType: 'degisken' },
  { id: 'sarf', label: 'Sarf Malzeme', defaultType: 'degisken' },
  { id: 'diger', label: 'Diğer', defaultType: 'degisken' }
];

export const GIDER_ODEME = [
  { id: 'nakit', label: 'Nakit' },
  { id: 'havale', label: 'Havale / EFT' },
  { id: 'kredi_karti', label: 'Kredi Kartı' },
  { id: 'diger', label: 'Diğer' }
];

export const PERSONEL_GIDER_KALEMLERI = ['personel', 'maas', 'sgk', 'prim', 'yemek', 'yol'];

export const FINANCE_SETTINGS_DOC = 'maliyet';

export const DEFAULT_FINANCE_COST_SETTINGS = {
  // Maliyet, has SATIS fiyatiyla carpilir (kullanici karari 2026-09-28).
  defaultGoldRateSource: GOLD_RATE_SOURCE.LIVE_SELL,
  // Kredi karti ile tahsil edilen tutardan bankanin kestigi komisyon (%).
  // Kar hesabina gider olarak giriyor; sube bazinda finansAyarlari/maliyet
  // dokumaninda degistirilebilir (kullanici karari 2026-09-29).
  posCommissionPct: 3,
  snapshotOnSale: true,
  milyemByProductType: {}
};

export function emptyCostBreakdown() {
  return {
    goldTry: 0,
    laborTry: 0,
    stoneTry: 0,
    additionalTry: 0,
    totalTry: 0
  };
}
